export const NO_PAGES_ICON_SIZE = 80
